'use strict';

module.exports = '3.24.1';
